import React from "react";
import { useState, useEffect } from "react";
import api from "../services/api";
function RolesPastilles(props) {
  const [roles, setRoles] = useState([]);
  const getRoles = () => {
    api
      .get("/roles/" + props.id)
      .then((response) => {
        const data = response.data;
        setRoles(data);
      })
      .catch((error) => {
        console.error("There was an error creating a calf!", error);
      });
  };
  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div className="flex">
      {roles.map((item, index) => (
        <div
          key={item.name + index}
          className={
            "mr-1 rounded-full border px-2 py-[2px] font-medium " +
            (item.name === "user"
              ? "border-blue-600 bg-blue-50 text-blue-600"
              : "border-orange-500 bg-orange-50 text-orange-500")
          }
        >
          {item.name}
        </div>
      ))}
    </div>
  );
}

export default RolesPastilles;
